document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('.main-people .swiper-container')
  if (!el) return

  const swiper = new Swiper(el, {
    loop: false,
    speed: 600,
    slidesPerView: 2.2,
    spaceBetween: 8,
    centeredSlides: false,
    navigation: {
      nextEl: '.main-people__controller-next',
      prevEl: '.main-people__controller-prev',
    },
    a11y: {
      prevSlideMessage: 'Go to previous slide',
      nextSlideMessage: 'Go to next slide',
      paginationBulletMessage: 'Go to slide {{index}}',
    },
    breakpoints: {
      1024: {
        slidesPerView: 5,
        spaceBetween: 16,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
    },
  })
})
